import React from 'react';
import { connect } from 'react-redux';

// selectors
import {
  isGCSMember,
  hasMemberInfoArrived
} from 'src/universal/redux/cardMemberInfo';
import { isProspect } from 'src/universal/redux/userType';
import { getPageFeatureFlags } from 'src/universal/redux/page';

// components
import { ProductAgnosticHero } from 'src/universal/components/ProductAgnosticHero';
import CmTabbedHero from 'src/universal/components/CmTabbedHero';
import HeroWaitingModule from 'src/universal/components/CmTabbedHero/HeroWaitingModule';
import ProspectTabbedHero from 'src/universal/components/ProspectTabbedHero';

const DynamicHero = ({
  featureFlags,
  hasMemberInfoArrived,
  isGCS,
  handleToggleSuppModal,
  isProspectUser
}) => {
  const { showProductAgnosticBanner } = featureFlags;

  if (isProspectUser || (hasMemberInfoArrived && !isGCS)) {
    return showProductAgnosticBanner ? (
      <ProductAgnosticHero />
    ) : (
      <ProspectTabbedHero />
    );
  } else if (hasMemberInfoArrived && isGCS) {
    return <CmTabbedHero cmToolTipToggle={handleToggleSuppModal} />;
  } else {
    return <HeroWaitingModule />;
  }
};

const mapStateToProps = state => {
  return {
    featureFlags: getPageFeatureFlags(state),
    hasMemberInfoArrived: hasMemberInfoArrived(state),
    isGCS: isGCSMember(state),
    isProspectUser: isProspect(state)
  };
};

export default connect(mapStateToProps)(DynamicHero);
